export default __webpack_public_path__ + "static/media/img2.4ffe666c.png";